import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {createColumnHelper} from "@tanstack/react-table";
import { useCommonColumns } from "../../../../utils/hooks/useCommonColumns";
import { useIsMasterCompany } from "../../../../utils/hooks/company";

const columnHelper = createColumnHelper();

export const useColumns = ({ edit, remove, clone, history }) => {
	const { t } = useTranslation();
	const isMasterCompany = useIsMasterCompany();

	const {
        code,
        description,
        status,
    } = useCommonColumns();

	return useMemo(() => {
		const columns = [
			code,
			description,
			status,
			columnHelper.accessor("startDay", {
				header: t("start-day"),
			}),
			columnHelper.accessor("isMain", {
				header: t("is-default"),
				cell: (info) => {
                    const value = info.getValue();
                    return value ? t("yes") : t("no");
                },
			}),
			columnHelper.accessor("color", {
				header: t("color"),
				cell: (info) => (
					<span
						style={{
							backgroundColor: info.getValue(),
							borderRadius: "10px",
							display: "inline-block",
							border: "1px solid #dee2e6",
							height: "12px",
							width: "12px",
						}}
					/>
				),
			}),
		];
		if (isMasterCompany) {
			columns.push(columnHelper.display({
				id: "actions",
				enableHiding: false,
				enableColumnFilter: false,
				header: (
					<div className="text-right">
						{t("actions")}
					</div>
				),
				cell: (info) => {
					const { id, company, isDefault } = info.row.original;

					return (
						<div className="actions text-primary text-right">
							{company && !isDefault && edit && (
								<span
									className="btn-inner--icon mr-3 icon-sm cursor-pointer"
									onClick={() => edit(id)}
									title={t("Edit")}
								>
									<i className="fas fa-pen" />
								</span>
							)}

							{company && !isDefault && remove && (
								<span
									className="btn-inner--icon mr-3 icon-sm cursor-pointer"
									onClick={() => remove(id)}
									title={t("Delete")}
								>
									<i className="fas fa-trash" />
								</span>
							)}

							{clone && (
								<span
									className="btn-inner--icon icon-sm cursor-pointer"
									onClick={() => clone(id)}
									title={t("Clone")}
								>
									<i className="ni ni-single-copy-04" />
								</span>
							)}

							{history && (
								<span
									className="btn-inner--icon icon-sm cursor-pointer ml-3"
									onClick={() => history(id)}
									title={t("history")}
								>
									<i className="fa-solid fa-clock-rotate-left" />
								</span>
							)}
						</div>
					);
				},
			}));
		}
		return columns;
	}, [
		t,
		isMasterCompany,
		code,
		description,
		status,
		history,
		clone,
		edit,
		remove
	]);
};
